// One naming rule for every lead: real name on top (else phone, else @username); phone · @username · channel · name source below.
import dayjs from 'dayjs';
import { MYT } from '@/lib/date';

const GENERIC = /^(unknown contact|contact|unknown)$/i;
export const CHANNEL = { whatsapp: 'WhatsApp', instagram: 'Instagram', messenger: 'Facebook' };
export const NAME_FROM = { wa_profile: 'from WhatsApp profile', wa_contact_book: 'from Business-app contacts', meta_profile: 'from Meta profile', staff: 'set by staff' };

export const handle = (c) => (c?.username ? `@${String(c.username).replace(/^@/, '')}` : null);

export const realName = (c) => {
  if (!c) return null;
  if (c.name && String(c.name).trim()) return String(c.name).trim();
  const d = String(c.display_name || '').trim();
  if (!d || GENERIC.test(d) || d === c.phone || d === c.email) return null;
  const u = String(c.username || '').replace(/^@/, '');
  if (u && (d === u || d === `@${u}`)) return null;
  if (!/[a-z]/i.test(d)) return null;  // only digits / symbols: a phone number, not a name
  return d;
};

const FALLBACK = { whatsapp: 'WhatsApp contact', instagram: 'Instagram contact', messenger: 'Facebook contact', 'walk-in': 'Walk-in', 'meta lead ad': 'Lead form contact' };
// No name, phone, username or email: say where they came from and when, so nameless leads don't all look alike.
const fallbackTitle = (c) => {
  const ch = String(c?.channel_primary || c?.platform || '').toLowerCase();
  const day = c?.first_captured ? dayjs.utc(c.first_captured).tz(MYT).format('D MMM') : '';
  return [FALLBACK[ch] || 'Unnamed contact', day].filter(Boolean).join(' · ');
};

export const contactTitle = (c) => realName(c) || c?.phone || handle(c) || c?.email || fallbackTitle(c);

export const contactBits = (c, { channel = true, source = true } = {}) => {
  if (!c) return [];
  const title = contactTitle(c);
  const ch = CHANNEL[String(c.channel_primary || c.platform || '').toLowerCase()];
  return [
    c.phone, handle(c), !c.phone && !handle(c) ? c.email : null,
    channel ? ch : null,
    source && realName(c) && c.name ? NAME_FROM[c.name_source] : null,
  ].filter((x) => x && x !== title);
};
